import * as plugins from "./plugins.js";
import * as woocommerce from "./woocommerce.js";
import * as user from "./user.js";
import * as tracking from "./tracking.js";
import * as chat from "./chat.js";
import * as popup from "./popup.js";
import * as google from "./google.js";
//import * as js_composer from './js_composer_critical.js';

jQuery(window).on("load", function () {
  // console.log('main running at', new Date().toISOString());
  plugins.init();

  woocommerce.init();

  tracking.init();

  popup.init();

  chat.init();

  user.init();

  google.init();

  // setTimeout(function () {
  //     js_composer.init();
  // }, 500);
});
